import { FULL_ROUTES } from './FULL';

export const ROUTE_GROUPS = {
	APP: [
		FULL_ROUTES.DASHBOARD,
		FULL_ROUTES.INITIATIVES,
		FULL_ROUTES.ISSUES,
		FULL_ROUTES.PERISCOPE,
		FULL_ROUTES.SETTINGS,
		FULL_ROUTES.SYNC,
		FULL_ROUTES.TAGS
	],
	APPLICATION_MONITORING: [
		FULL_ROUTES.ADD_APP,
		FULL_ROUTES.APPLICATION_MONITOR,
		FULL_ROUTES.APPLICATION_MONITORING,
		FULL_ROUTES.API_VOLUME,
		FULL_ROUTES.APPLICATION_SETUP
	],
	DASHBOARD: [
		FULL_ROUTES.DASHBOARD,
		FULL_ROUTES.EXPORT
	],
	DATA_SECURITY: [
		FULL_ROUTES.DATA_ACCESS,
		FULL_ROUTES.DATA_ACCESS_ACCESS_AUDIT,
		FULL_ROUTES.DATA_ACCESS_ACCESS_COMPARE,
		FULL_ROUTES.DATA_ACCESS_ACCESS_COMPARE_FIELDS,
		FULL_ROUTES.DATA_ACCESS_ACCESS_EXPLAINER,
		FULL_ROUTES.DATA_ACCESS_ACCESS_EXPLAINER_FIELDS
	],
	INITIATIVES: [
		FULL_ROUTES.INITIATIVES,
		FULL_ROUTES.INITIATIVES_DETAIL
	],
	MONITORS_AND_LOGS: [
		FULL_ROUTES.MONITORS,
		FULL_ROUTES.SETUP_AUDIT_TRAIL,
		FULL_ROUTES.TIMELINE
	],
	ONBOARDING: [
		FULL_ROUTES.ONBOARDING_CONFIRM,
		FULL_ROUTES.ONBOARDING_CONNECT,
		FULL_ROUTES.ONBOARDING_SYNC
	],
	SETTINGS: [
		FULL_ROUTES.SETTINGS,
		FULL_ROUTES.SETTINGS_INTEGRATIONS,
		FULL_ROUTES.SETTINGS_ORGANIZATION,
		FULL_ROUTES.SETTINGS_TEAM,
		FULL_ROUTES.SETTINGS_USER
	]
};
